import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "stats-page" };
const _hoisted_2 = { class: "container py-5" };
const _hoisted_3 = { class: "row align-items-center g-4 mb-5" };
const _hoisted_4 = { class: "col-lg-8" };
const _hoisted_5 = { class: "display-5 fw-bold mb-3" };
const _hoisted_6 = { class: "text-muted fs-5 mb-0" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { key: 1 };
const _hoisted_9 = { class: "col-lg-4" };
const _hoisted_10 = { class: "stats-tabs" };
const _hoisted_11 = ["disabled"];
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { key: 1 };
const _hoisted_14 = ["disabled"];
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { key: 1 };
const _hoisted_17 = {
    key: 0,
    class: "stats-content"
};
const _hoisted_18 = { class: "row g-4 mt-1" };
const _hoisted_19 = { class: "col-lg-6" };
const _hoisted_20 = { class: "col-lg-6" };
const _hoisted_21 = { class: "panel mt-4" };
const _hoisted_22 = { class: "table-responsive stats-table-wrapper" };
const _hoisted_23 = { class: "table stats-table align-middle mb-0" };
const _hoisted_24 = {
    key: 0,
    class: "text-muted ms-1"
};
const _hoisted_25 = { class: "text-end" };
const _hoisted_26 = { class: "text-end" };
const _hoisted_27 = { class: "text-end fw-semibold" };
const _hoisted_28 = { class: "text-end" };
const _hoisted_29 = { class: "text-end" };
const _hoisted_30 = {
    key: 1,
    class: "stats-content"
};
const _hoisted_31 = { class: "row g-4 mt-1" };
const _hoisted_32 = { class: "col-lg-6" };
const _hoisted_33 = { class: "col-lg-6" };
const _hoisted_34 = { class: "panel mt-4" };
const _hoisted_35 = { class: "table-responsive stats-table-wrapper" };
const _hoisted_36 = { class: "table stats-table align-middle mb-0" };
const _hoisted_37 = {
    key: 0,
    class: "text-muted ms-1"
};
const _hoisted_38 = { class: "text-end" };
const _hoisted_39 = { class: "text-end" };
const _hoisted_40 = { class: "text-end" };
const _hoisted_41 = { class: "text-end fw-semibold" };
const _hoisted_42 = { class: "text-end" };
import { ref } from 'vue';
import TravelerTrendChart from '@/components/stats/TravelerTrendChart.vue';
import TravelerModalityChart from '@/components/stats/TravelerModalityChart.vue';
import ExpenseTrendChart from '@/components/stats/ExpenseTrendChart.vue';
import ExpenseCategoryChart from '@/components/stats/ExpenseCategoryChart.vue';
import travelerYearSummaries from '@/data/travelers';
import touristExpenseYears from '@/data/tourist-expenses';
import pdfService from '@/services/pdf.service';
export default /*@__PURE__*/ _defineComponent({
    __name: 'StatsPage',
    setup(__props) {
        const activeTab = ref('travelers');
        const downloadingPDF = ref(false);
        // Referencias a los elementos de los gráficos
        const travelerChart1Ref = ref(null);
        const travelerChart2Ref = ref(null);
        const expenseChart1Ref = ref(null);
        const expenseChart2Ref = ref(null);
        const chartLabels = travelerYearSummaries.map(entry => entry.year.toString());
        const expenseChartLabels = touristExpenseYears.map(entry => entry.year.toString());
        const trendChartDatasets = [
            {
                label: 'Total general',
                data: travelerYearSummaries.map(entry => entry.overall.total),
                borderColor: '#2563eb',
                backgroundColor: 'rgba(37, 99, 235, 0.12)'
            },
            {
                label: 'Visitantes extranjeros',
                data: travelerYearSummaries.map(entry => entry.overall.foreign),
                borderColor: '#f97316',
                backgroundColor: 'rgba(249, 115, 22, 0.12)'
            }
        ];
        const modalityDatasets = [
            {
                label: 'Aéreo',
                data: travelerYearSummaries.map(entry => entry.air.total),
                backgroundColor: 'rgba(14, 165, 233, 0.85)'
            },
            {
                label: 'Carretero',
                data: travelerYearSummaries.map(entry => entry.road.total),
                backgroundColor: 'rgba(37, 99, 235, 0.85)'
            }
        ];
        const travelerRows = travelerYearSummaries.map((entry, index) => {
            const previous = index > 0 ? travelerYearSummaries[index - 1] : undefined;
            const yoy = previous
                ? ((entry.overall.total - previous.overall.total) / previous.overall.total) * 100
                : null;
            return { entry, yoy };
        });
        function formatNumber(value) {
            return value.toLocaleString('es-BO');
        }
        function formatPercent(value) {
            if (value === null || Number.isNaN(value))
                return '—';
            const formatted = value.toFixed(1);
            return `${value >= 0 ? '+' : ''}${formatted}%`;
        }
        function getYoYBadgeClass(value) {
            if (value === null)
                return 'badge text-bg-secondary-subtle text-secondary';
            return value >= 0
                ? 'badge text-bg-success-subtle text-success'
                : 'badge text-bg-danger-subtle text-danger';
        }
        function getProvisionalLabel(entry) {
            return entry.provisional ? '(preliminar)' : '';
        }
        // Datos de gastos
        const expenseTrendDatasets = [
            {
                label: 'Gasto total',
                data: touristExpenseYears.map(entry => entry.expenses.total),
                borderColor: '#10b981',
                backgroundColor: 'rgba(16, 185, 129, 0.12)'
            }
        ];
        const expenseCategoryDatasets = [
            {
                label: 'Alojamiento',
                data: touristExpenseYears.map(entry => entry.expenses.accommodation),
                backgroundColor: 'rgba(59, 130, 246, 0.85)'
            },
            {
                label: 'Compra de Bienes',
                data: touristExpenseYears.map(entry => entry.expenses.goods.total),
                backgroundColor: 'rgba(168, 85, 247, 0.85)'
            },
            {
                label: 'Gasto en Servicios',
                data: touristExpenseYears.map(entry => entry.expenses.services.total),
                backgroundColor: 'rgba(236, 72, 153, 0.85)'
            }
        ];
        const expenseRows = touristExpenseYears.map((entry, index) => {
            const previous = index > 0 ? touristExpenseYears[index - 1] : undefined;
            const yoy = previous
                ? ((entry.expenses.total - previous.expenses.total) / previous.expenses.total) * 100
                : null;
            return { entry, yoy };
        });
        function formatCurrency(value) {
            return value.toFixed(2);
        }
        // Funciones para descargar PDFs
        async function downloadTravelersPDF() {
            downloadingPDF.value = true;
            try {
                // Esperar un momento para que los gráficos se rendericen completamente
                await new Promise(resolve => setTimeout(resolve, 500));
                const tableData = travelerRows.map(({ entry, yoy }) => ({
                    year: entry.year,
                    air: entry.air.total,
                    road: entry.road.total,
                    total: entry.overall.total,
                    yoy: yoy,
                    foreignPercent: (entry.overall.foreign / entry.overall.total) * 100,
                    provisional: entry.provisional
                }));
                await pdfService.generateTravelersPDF(travelerChart1Ref.value, travelerChart2Ref.value, tableData, {
                    title: 'Llegada de Viajeros Internacionales',
                    subtitle: 'Serie histórica de visitantes',
                    source: 'Instituto Nacional de Estadística / Dirección General de Migración',
                    period: '2008 - 2025'
                });
            }
            catch (error) {
                console.error('Error generando PDF de viajeros:', error);
                alert('Error al generar el PDF. Por favor, intente nuevamente.');
            }
            finally {
                downloadingPDF.value = false;
            }
        }
        async function downloadExpensesPDF() {
            downloadingPDF.value = true;
            try {
                // Esperar un momento para que los gráficos se rendericen completamente
                await new Promise(resolve => setTimeout(resolve, 500));
                const tableData = expenseRows.map(({ entry, yoy }) => ({
                    year: entry.year,
                    accommodation: entry.expenses.accommodation,
                    goods: entry.expenses.goods.total,
                    services: entry.expenses.services.total,
                    total: entry.expenses.total,
                    yoy: yoy,
                    provisional: entry.provisional
                }));
                await pdfService.generateExpensesPDF(expenseChart1Ref.value, expenseChart2Ref.value, tableData, {
                    title: 'Gasto Turístico de Visitantes Extranjeros',
                    subtitle: 'Gastos en millones de dólares estadounidenses',
                    source: 'Instituto Nacional de Estadística / Banco Central de Bolivia / Viceministerio de Turismo',
                    period: '2008 - 2024'
                });
            }
            catch (error) {
                console.error('Error generando PDF de gastos:', error);
                alert('Error al generar el PDF. Por favor, intente nuevamente.');
            }
            finally {
                downloadingPDF.value = false;
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "badge text-bg-light text-uppercase fw-semibold mb-3" }, "Datos oficiales", -1)),
                            _createElementVNode("h1", _hoisted_5, _toDisplayString(activeTab.value === 'travelers' ? 'Llegada de viajeros internacionales' : 'Gasto turístico de visitantes extranjeros'), 1),
                            _createElementVNode("p", _hoisted_6, [
                                (activeTab.value === 'travelers')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Serie histórica publicada por el Instituto Nacional de Estadística y la Dirección General de Migración (2008 - 2025). Los módulos inferiores sólo muestran información proveniente de dicho registro. "))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_8, " Datos publicados por el Instituto Nacional de Estadística, Banco Central de Bolivia y Viceministerio de Turismo (2008 - 2024). Valores en millones de dólares estadounidenses. "))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("button", {
                                    onClick: _cache[0] || (_cache[0] = ($event) => (activeTab.value = 'travelers')),
                                    class: _normalizeClass(['tab-btn', { active: activeTab.value === 'travelers' }])
                                }, [...(_cache[3] || (_cache[3] = [
                                        _createElementVNode("i", { class: "fas fa-users me-2" }, null, -1),
                                        _createTextVNode(" Viajeros ", -1)
                                    ]))], 2),
                                _createElementVNode("button", {
                                    onClick: _cache[1] || (_cache[1] = ($event) => (activeTab.value = 'expenses')),
                                    class: _normalizeClass(['tab-btn', { active: activeTab.value === 'expenses' }])
                                }, [...(_cache[4] || (_cache[4] = [
                                        _createElementVNode("i", { class: "fas fa-dollar-sign me-2" }, null, -1),
                                        _createTextVNode(" Gastos ", -1)
                                    ]))], 2)
                            ]),
                            (activeTab.value === 'travelers')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: downloadTravelersPDF,
                                    disabled: downloadingPDF.value,
                                    class: "download-btn mt-3"
                                }, [
                                    _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-file-pdf me-2" }, null, -1)),
                                    (downloadingPDF.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Generando PDF..."))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_13, "Descargar PDF"))
                                ], 8, _hoisted_11))
                                : _createCommentVNode("", true),
                            (activeTab.value === 'expenses')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    onClick: downloadExpensesPDF,
                                    disabled: downloadingPDF.value,
                                    class: "download-btn mt-3"
                                }, [
                                    _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-file-pdf me-2" }, null, -1)),
                                    (downloadingPDF.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Generando PDF..."))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_16, "Descargar PDF"))
                                ], 8, _hoisted_14))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    (activeTab.value === 'travelers')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", {
                                        class: "panel h-100",
                                        ref_key: "travelerChart1Ref",
                                        ref: travelerChart1Ref
                                    }, [
                                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "panel-header" }, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("h4", { class: "mb-1" }, "Evolución anual de viajeros"),
                                                _createElementVNode("small", { class: "text-muted" }, "Variación total vs. extranjeros")
                                            ]),
                                            _createElementVNode("span", { class: "badge text-bg-primary-subtle text-primary" }, "Dinámico")
                                        ], -1)),
                                        _createVNode(TravelerTrendChart, {
                                            labels: _unref(chartLabels),
                                            datasets: trendChartDatasets
                                        }, null, 8, ["labels"])
                                    ], 512)
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", {
                                        class: "panel h-100",
                                        ref_key: "travelerChart2Ref",
                                        ref: travelerChart2Ref
                                    }, [
                                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "panel-header" }, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("h4", { class: "mb-1" }, "Modalidad de ingreso"),
                                                _createElementVNode("small", { class: "text-muted" }, "Comparativo entre vías aéreas y carreteras")
                                            ]),
                                            _createElementVNode("span", { class: "badge text-bg-info-subtle text-info" }, "Stacked")
                                        ], -1)),
                                        _createVNode(TravelerModalityChart, {
                                            labels: _unref(chartLabels),
                                            datasets: modalityDatasets
                                        }, null, 8, ["labels"])
                                    ], 512)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "panel-header flex-column flex-md-row align-items-md-center" }, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("h4", { class: "mb-1" }, "Serie histórica de viajeros internacionales"),
                                        _createElementVNode("small", { class: "text-muted" }, "Fuente: Instituto Nacional de Estadística / Dirección General de Migración")
                                    ]),
                                    _createElementVNode("span", { class: "badge text-bg-light text-uppercase" }, "2008 – 2025")
                                ], -1)),
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("table", _hoisted_23, [
                                        _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, "Año"),
                                                _createElementVNode("th", { class: "text-end" }, "Aéreo (total)"),
                                                _createElementVNode("th", { class: "text-end" }, "Carretero (total)"),
                                                _createElementVNode("th", { class: "text-end" }, "Total general"),
                                                _createElementVNode("th", { class: "text-end" }, "YoY"),
                                                _createElementVNode("th", { class: "text-end" }, "% extranjeros")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(travelerRows), ({ entry, yoy }) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: entry.year
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("strong", null, _toDisplayString(entry.year), 1),
                                                        (entry.provisional)
                                                            ? (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(getProvisionalLabel(entry)), 1))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_25, _toDisplayString(formatNumber(entry.air.total)), 1),
                                                    _createElementVNode("td", _hoisted_26, _toDisplayString(formatNumber(entry.road.total)), 1),
                                                    _createElementVNode("td", _hoisted_27, _toDisplayString(formatNumber(entry.overall.total)), 1),
                                                    _createElementVNode("td", _hoisted_28, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(getYoYBadgeClass(yoy))
                                                        }, _toDisplayString(formatPercent(yoy)), 3)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_29, _toDisplayString(formatPercent((entry.overall.foreign / entry.overall.total) * 100)), 1)
                                                ]));
                                            }), 128))
                                        ])
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (activeTab.value === 'expenses')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", {
                                        class: "panel h-100",
                                        ref_key: "expenseChart1Ref",
                                        ref: expenseChart1Ref
                                    }, [
                                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "panel-header" }, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("h4", { class: "mb-1" }, "Evolución del gasto total"),
                                                _createElementVNode("small", { class: "text-muted" }, "Gasto turístico anual en millones USD")
                                            ]),
                                            _createElementVNode("span", { class: "badge text-bg-success-subtle text-success" }, "Dinámico")
                                        ], -1)),
                                        _createVNode(ExpenseTrendChart, {
                                            labels: _unref(expenseChartLabels),
                                            datasets: expenseTrendDatasets
                                        }, null, 8, ["labels"])
                                    ], 512)
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", {
                                        class: "panel h-100",
                                        ref_key: "expenseChart2Ref",
                                        ref: expenseChart2Ref
                                    }, [
                                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "panel-header" }, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("h4", { class: "mb-1" }, "Distribución por categoría"),
                                                _createElementVNode("small", { class: "text-muted" }, "Alojamiento, Bienes y Servicios")
                                            ]),
                                            _createElementVNode("span", { class: "badge text-bg-warning-subtle text-warning" }, "Stacked")
                                        ], -1)),
                                        _createVNode(ExpenseCategoryChart, {
                                            labels: _unref(expenseChartLabels),
                                            datasets: expenseCategoryDatasets
                                        }, null, 8, ["labels"])
                                    ], 512)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "panel-header flex-column flex-md-row align-items-md-center" }, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("h4", { class: "mb-1" }, "Serie histórica de gasto turístico"),
                                        _createElementVNode("small", { class: "text-muted" }, "Fuente: Instituto Nacional de Estadística / Banco Central de Bolivia / Viceministerio de Turismo")
                                    ]),
                                    _createElementVNode("span", { class: "badge text-bg-light text-uppercase" }, "2008 – 2024")
                                ], -1)),
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("table", _hoisted_36, [
                                        _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, "Año"),
                                                _createElementVNode("th", { class: "text-end" }, "Alojamiento"),
                                                _createElementVNode("th", { class: "text-end" }, "Compra de Bienes"),
                                                _createElementVNode("th", { class: "text-end" }, "Gasto en Servicios"),
                                                _createElementVNode("th", { class: "text-end" }, "Total"),
                                                _createElementVNode("th", { class: "text-end" }, "YoY")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(expenseRows), ({ entry, yoy }) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: entry.year
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("strong", null, _toDisplayString(entry.year), 1),
                                                        (entry.provisional)
                                                            ? (_openBlock(), _createElementBlock("small", _hoisted_37, "(preliminar)"))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_38, "$" + _toDisplayString(formatCurrency(entry.expenses.accommodation)), 1),
                                                    _createElementVNode("td", _hoisted_39, "$" + _toDisplayString(formatCurrency(entry.expenses.goods.total)), 1),
                                                    _createElementVNode("td", _hoisted_40, "$" + _toDisplayString(formatCurrency(entry.expenses.services.total)), 1),
                                                    _createElementVNode("td", _hoisted_41, "$" + _toDisplayString(formatCurrency(entry.expenses.total)), 1),
                                                    _createElementVNode("td", _hoisted_42, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(getYoYBadgeClass(yoy))
                                                        }, _toDisplayString(formatPercent(yoy)), 3)
                                                    ])
                                                ]));
                                            }), 128))
                                        ])
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
